import { pdp_alternate_flow_test_one } from './featureFlags';
import { useFeatureFlag } from './useExperiment';
/**
 * Determines which PDP experience to show for eligible products.
 *
 * The pdp_alternate_flow_test_one Convert A/B test has concluded with the variation as the
 * winner, so the V2 layout is now controlled solely by the LaunchDarkly flag (rolled out
 * per site/brand) rather than a live Convert bucket — no loading state is needed since the
 * flag resolves synchronously from SiteContext.
 *
 * @param isProductEligible — whether the current product qualifies for the V2 layout.
 *   Use `!product.isFuneral` to match the same eligibility as the live alternate flow.
 */
export const usePdpV2ExperienceGate = (isProductEligible) => {
    const flagResponse = useFeatureFlag(pdp_alternate_flow_test_one.key);
    // LaunchDarkly returns {} (not a boolean) when the flag is off — !!flagResponse alone would be true for {}
    const isFlagEnabled = !!flagResponse && Object.keys(flagResponse).length > 0;
    const isVariation = isProductEligible && isFlagEnabled;
    return { experience: isVariation ? 'variation' : 'control', isVariation };
};
